import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { DivisionProfile } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to get division profiles
 */
@Injectable()
export class DivisionProfileService {
    public static get ESPORTS(): string {
        return '24293fcf-5416-4209-8edb-f2941795822b';
    }

    public static get INCLUDE_WT_CLASS_GROUPS_W_WEIGHTS(): string {
        return 'weightClassGroups.weights';
    }

    private allowedDivisionProfileIds: string[];

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
        this.allowedDivisionProfileIds = http.configService.getSportConfig('divisionProfiles');
    }

    /**
     * Get all enabled division profiles
     */
    public getIndex(forceRefresh: boolean = false): Observable<DivisionProfile[]> {
        // const apiUrl: string = this.http.configService.getApiBaseUrl() + '/division-profiles/?isEnabled=1';
        const apiRequestUrl: string = this.getApiUrl(null, null, ['isEnabled=1']);

        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const divisionProfiles: DivisionProfile[] = [];

                const bodyData: any = response.data || [];
                for (const divisionProfile of bodyData) {
                    const id: string = divisionProfile.id;

                    // Filter out the division profiles that are not configured for the current sport
                    if (this.allowedDivisionProfileIds &&
                        this.allowedDivisionProfileIds.filter(
                            (x: string) => x.toLowerCase() === id.toLowerCase(),
                        ).length > 0) {
                        divisionProfiles.push(
                            (new DivisionProfile()).deserialize(divisionProfile, response.included),
                        );
                    }
                }

                return divisionProfiles;
            }));
    }

    /**
     * Get a single divisionProfile data
     */
    public get(divisionProfileId: string, includes: string[]): Observable<DivisionProfile> {
        const apiRequestUrl: string = this.getApiUrl(divisionProfileId, includes);

        return this.http.get(apiRequestUrl)
            .pipe(
                map((response: IJsonApiResponse) => (new DivisionProfile().deserialize(response, response.included))),
            );
    }

    /**
     * Build the api's url base on the specified parameters
     */
    private getApiUrl(divisionProfileId: string, includes: string[] = null, queryParams: string[] = null): string {
        let url: string = `${this.http.configService.getApiBaseUrl()}/division-profiles/`;

        if (divisionProfileId) {
            url += divisionProfileId;
        }

        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}
